import React, { useEffect, useRef, useState } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import ReactPlayer from 'react-player';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import VideoControls from './VideoControls';
import gameService from '../../services/game.service';

const styles = {
    controls: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 999,
        alignItems: 'center',
        position: 'fixed',
        left: 0,
        bottom: '16px',
        justifyContent: 'center',
        width: '100%',
        gap: '0.2rem'
    }
};

const FullVideoPlayer = ({ video_url, muteState, setFullVideo, IsSkills }) => {
    const handle = useFullScreenHandle();
    const player = useRef(null);
    const [play, setPlay] = useState(true);
    const [currentTime, setCurrentTime] = useState(0);
    const [videoURL, setVideoURL] = useState('');
    const [duration, setDuration] = useState(0);
    const [, setCurIdx] = useState(0);
    const [playRate, setPlayRate] = useState(1);
    const [muted, setMuted] = useState(muteState ?? false);

    const seekTo = (seconds) => {
        const target = Math.min(Math.max(seconds, 0), duration || seconds);

        player.current && player.current.seekTo(target, 'seconds');
        setCurrentTime(target);
    };

    const PlayVideo = (num) => {
        let index;
        setPlay(true);
        setCurIdx(index);
    };

    useEffect(() => {
        if (video_url?.includes('youtube.com') || video_url?.includes('youtu.be')) {
            gameService.getNewStreamURL(video_url).then((res) => {
                setVideoURL(res.result.video_url);
            });
        } else setVideoURL(video_url);
    }, [video_url]);

    return (
        <FullScreen handle={handle}>
            <div className="player-shared-wrapper tag-video">
                <ReactPlayer
                    className="react-shared-player"
                    url={videoURL}
                    ref={player}
                    onPlay={() => setPlay(true)}
                    onPause={() => setPlay(false)}
                    onProgress={(p) => setCurrentTime(p.playedSeconds)}
                    progressInterval={250}
                    onDuration={(d) => setDuration(d)}
                    playing={play}
                    muted={muted}
                    playbackRate={playRate}
                    controls={false}
                    width="100%"
                    height="100%"
                />
            </div>
            <IconButton
                aria-label="close"
                onClick={(e) => setFullVideo(false)}
                sx={{
                    position: 'fixed',
                    right: 8,
                    top: 8,
                    zIndex: 9999,
                    color: 'red'
                }}
            >
                <CloseIcon />
            </IconButton>
            <div style={styles.controls}>
                <VideoControls
                    // The play button doubles as a speed reset, as it always has here:
                    // while Slow or Fast is engaged it drops back to 1x instead of pausing.
                    playing={play && playRate === 1}
                    muted={muted}
                    fullscreen={handle.active}
                    position={currentTime}
                    duration={duration}
                    onTogglePlay={() => {
                        if (playRate === 1) setPlay((p) => !p);
                        else setPlayRate(1);
                    }}
                    onSeekBy={(delta) => seekTo((player.current?.getCurrentTime() ?? currentTime) + delta)}
                    onScrub={(seconds) => seekTo(seconds)}
                    onSlow={() => setPlayRate(0.5)}
                    onFast={() => setPlayRate((s) => s + 0.5)}
                    onToggleMute={() => setMuted((m) => !m)}
                    onToggleFullscreen={() => (handle.active ? handle.exit() : handle.enter())}
                    showSkip={IsSkills}
                    onPrev={() => PlayVideo(1)}
                    onNext={() => PlayVideo(1)}
                />
            </div>
        </FullScreen>
    );
};
export default FullVideoPlayer;
